import $ from 'jquery';
import slick from 'slick-carousel';
export default () => {
  var ChallengesSliderController = (function () {
    let isBackend = ($('body[data-backend]').length > 0);

    var initSlider = function () {
      let slider = null;
      let slidingAutoplayDelayMs = 3000;
      let isRtl = $("html").attr("dir") === "rtl";
      let urlsThatShouldBeOneRow = ['/100-day-challenge/', '/ar/100-day-challenge/', '/cohorts/', '/ar/cohorts/'];

      $("[data-challenges-slider]").each(function () {
        slider = $(this);
        let slidesCount = slider.find('[data-slide]').length;
        let dotsContainer = slider.parents('.js-challenges-slider').find('[data-dots]');
        let arrowsContainer = slider.parents('.js-challenges-slider').find('[data-slider-nav]');
        let prevSliderArrow = '<button class="media-slider-arrow media-slider-arrow-prev js-slick-prev"></button>';
        let nextSliderArrow = '<button class="media-slider-arrow media-slider-arrow-next js-slick-next"></button>';
        let shouldSliderHaveTwoRows = slider.attr('data-two-rows');
        let rowsCount = 1;
        if (shouldSliderHaveTwoRows === 'true') {
          rowsCount = 2;
        }

        let defaultOptions = {
          dots: true,
          appendDots: dotsContainer,
          arrows: false,
          slidesPerRow: 3,
          infinite: false,
          rows: 0,
          variableWidth: true,
          accessibility: true,
          rtl: isRtl,
        };
        let singleOptions = {
          dots: false,
          appendDots: dotsContainer,
          slidesToShow: 3,
          variableWidth: true,
          accessibility: true,
          infinite: false,
          appendArrows: arrowsContainer,
          prevArrow: prevSliderArrow,
          nextArrow: nextSliderArrow,
          arrows: false,
          rtl: isRtl,
          responsive: [{
              breakpoint: 1200,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true
              }
            }
          ]
        };

        let colOptions = {
          dots: true,
          appendDots: dotsContainer,
          variableWidth: true,
          accessibility: true,
          autoplaySpeed: slidingAutoplayDelayMs,
          rtl: isRtl,
          appendArrows: arrowsContainer,
          prevArrow: prevSliderArrow,
          nextArrow: nextSliderArrow,
          slidesPerRow: 3,
          infinite: false,
          rows: 2,
          responsive: [{
              breakpoint: 1024,
              settings: {
                arrows: true,
                slidesPerRow: 1,
                rows: 1
              }
            },
            {
              breakpoint: 640,
              dots: false,
              settings: {
                slidesPerRow: 1,
                rows: 1
              }
            }
          ]
        };

        if (shouldSliderHaveTwoRows) {
          colOptions.rows = rowsCount;
        }

        let rowOptions = {
          dots: true,
          appendDots: dotsContainer,
          variableWidth: true,
          accessibility: true,
          autoplaySpeed: slidingAutoplayDelayMs,
          rtl: isRtl,
          appendArrows: arrowsContainer,
          prevArrow: prevSliderArrow,
          nextArrow: nextSliderArrow,
          slidesPerRow: 3,
          rows: rowsCount,
          infinite: false,
          responsive: [{
              breakpoint: 1024,
              settings: {
                slidesPerRow: 1,
                rows: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 1,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 1,
                arrows: true
              }
            }
          ]
        };

        if (isBackend == false) {
          let sliderShouldBeOnOneRowCheck = -1;
          urlsThatShouldBeOneRow.forEach(function (e) {
            if (window.location.pathname.indexOf(e) != -1) {
              sliderShouldBeOnOneRowCheck = 0;
            }
          });
          if (sliderShouldBeOnOneRowCheck != -1) {
            slider.slick(rowOptions);
          } else if (slidesCount > 3) {
            if (slidesCount < 5 && colOptions.rows == 2) {
              colOptions.dots = false;
            }
            slider.slick(colOptions);
          } else if (slidesCount === 3 || slidesCount === 2) {
            slider.slick(singleOptions);
          } else if (slidesCount === 1) {
            slider.slick(defaultOptions);
          }
        } else {
          if (slidesCount > 3) {
            if (slidesCount < 5 && colOptions.rows == 2) {
              colOptions.dots = false;
            }
            slider.slick(colOptions);
          } else if (slidesCount === 3 || slidesCount === 2) {
            slider.slick(singleOptions);
          } else if (slidesCount === 1) {
            slider.slick(defaultOptions);
          }
        }


      });
    };

    var init = function () {
      if ($("[data-challenges-slider]").length <= 0) {
        return;
      }

      initSlider();
    };

    return {
      init: init
    };
  })();
  $(function () {
    ChallengesSliderController.init();
  });

};
